import { Skeleton } from '@pu/mpp-ui/components/skeleton';
import { useCSS } from '@pu/mpp-ui/hooks';

import './side-nav-list-skeleton.scss';

export const SidenavListSkeleton = () => {
  const css = useCSS('side-nav-list-skeleton');
  return (
    <div className={css()} role="alert" aria-live="polite" aria-label="Cargando Módulos">
      {Array.from({ length: 7 }, (_, index) => (
        <Skeleton key={`skeleton-${index}`} className={css('item')} />
      ))}
    </div>
  );
};
